module.exports = __webpack_public_path__ + "img/radarBase.ad4e2814.png";